export enum LiveInterval {
  SECONDS_30 = 30 * 1000,
  MINUTES_1 = 60 * 1000,
  MINUTES_10 = 10 * 60 * 1000,
  HOURS_1 = 60 * 60 * 1000,
  DAY_1 = 24 * 60 * 60 * 1000,
}

export default { LiveInterval };
